import PropTypes from 'prop-types';
import React, { Component } from 'react';
import WaveSurfer from 'wavesurfer.js';
import MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.min';

class AudioRecordingVisualizer extends Component {
    componentDidMount() {
        const { microphoneOptions, options, container } = this.props;
        this.wavesurfer = WaveSurfer.create({
            container: `#${container}`,
            plugins: [
                MicrophonePlugin.create({
                    ...microphoneOptions,
                }),
            ],
            ...options,
        });
        this.startVisualizing();
    }

    componentWillUnmount() {
        this.wavesurfer.microphone.stop();
    }

    startVisualizing() {
        this.wavesurfer.microphone.start();
        this.wavesurfer.microphone.on('deviceError', this.props.onFailure);
    }

    render() {
        const { container } = this.props;
        return <div id={container} className={container} />;
    }
}

AudioRecordingVisualizer.propTypes = {
    options: PropTypes.shape({}),
    microphoneOptions: PropTypes.shape({}),
    onFailure: PropTypes.func,
    container: PropTypes.string,
};

AudioRecordingVisualizer.defaultProps = {
    options: {},
    microphoneOptions: {},
    onFailure: () => {},
    container: 'waveform',
};

export default AudioRecordingVisualizer;
